export const scopeNameComparator = (a, b) => a.name > b.name ? 1 : -1;